import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AccountsByApplicationSearchParams,
  IApplicationListItem,
} from 'src/app/shared/interfaces/account/account.interface';
import { IUserAccountDTO } from 'src/app/shared/interfaces/user/user.interface';

@Component({
  selector: 'app-add-account-to-user-modal',
  templateUrl: './add-account-to-user-modal.component.html',
})
export class AddAccountToUserModalComponent implements OnInit {
  @Input() userApplications?: IApplicationListItem[];
  @Input() userAccounts?: IUserAccountDTO[];

  accountsFiltersForm: UntypedFormGroup;
  checkedAccounts?: IUserAccountDTO[];
  searchParams: AccountsByApplicationSearchParams;
  isLoading: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.accountsFiltersForm = this.fb.group({
      name: [''],
      accountNumber: [''],
    });

    this.checkedAccounts = this.userAccounts;
  }

  doSearch() {
    const params = this.accountsFiltersForm.value;
    this.searchParams = params;
  }

  addGroups() {
    this.activeModal.close(this.checkedAccounts);
  }

  setAccounts(accounts: IUserAccountDTO[]) {
    this.checkedAccounts = accounts;
  }

  close() {
    this.activeModal.dismiss();
  }
}
